import React from 'react';
import classnames from 'classnames';
import { MdKeyboardArrowDown } from 'react-icons/md';
import DynamicLink from '../DynamicLink';
import * as styles from './GlobalNav.module.styl';
import SubMenuItem from './SubMenuItem';
import IntegrationItem from './IntegrationItem';
import Button from '../Button';
import FeaturedItem from './FeaturedItem';

const getFeaturedItem = (featuredItem = {}) => {
  const { link } = featuredItem;
  if (!(link?.link_url && link?.link_text)) return null;

  return <FeaturedItem featuredItem={featuredItem} isMobile />;
};

function MobileMenuItem({ item, isActive, setActiveSubMenu }) {
  if (!item) return null;

  const hasSubMenu =
    item?.sub_menu?.length > 0 ||
    item?.integrations?.length > 0 ||
    item?.help_menu?.length > 0 ||
    Object.keys(item.featured_item || {}).length === 0;

  return hasSubMenu ? (
    <>
      <div
        className={classnames(
          styles.mobileMenuLink,
          styles.mobileMenuItem,
          isActive ? styles.mobileMenuItemActive : null,
        )}
        onClick={() => setActiveSubMenu(isActive ? '' : item.title)}
      >
        {item.title}
        <MdKeyboardArrowDown
          style={{
            transform: isActive ? 'rotate(180deg)' : 'rotate(0deg)',
          }}
        />
      </div>
      <div
        className={classnames(
          styles.subMenuMobile,
          isActive ? styles.subMenuMobileOpen : null,
        )}
      >
        {item.sub_menu?.length > 0
          ? item.sub_menu.map((subItem, i) => (
              <SubMenuItem key={i} subItem={subItem} />
            ))
          : null}

        {item.integrations?.length > 0
          ? item.integrations.map((integration, i) => (
              <IntegrationItem key={i} integration={integration} isMobile />
            ))
          : null}

        {item.help_menu?.length > 0
          ? item.help_menu.map((subItem, i) => (
              <SubMenuItem key={i} subItem={subItem} />
            ))
          : null}

        {getFeaturedItem(item.featured_item)}
      </div>
    </>
  ) : (
    <DynamicLink
      activeClassName={styles.active}
      className={styles.mobileMenuLink}
      link={item.link_url}
    >
      {item.title}
    </DynamicLink>
  );
}

function MobileMenu({
  menu = [],
  menuOpen,
  activeSubMenu,
  setActiveSubMenu,
  registerUrl,
  registerText,
  isPapersign,
}) {
  return (
    <div
      className={classnames(
        styles.mobileMenu,
        menuOpen && styles.mobileMenuOpen,
      )}
    >
      {menu?.length > 0 ? (
        <div className={styles.mobileMenuContainer}>
          {menu.map((item) => (
            <MobileMenuItem
              item={item}
              key={item.title}
              isActive={activeSubMenu === item.title}
              setActiveSubMenu={setActiveSubMenu}
            />
          ))}
        </div>
      ) : null}
      <div className={styles.mobileMenuButtons}>
        {isPapersign
          ? [
              <Button to="/pdf-templates" md outline fullwidth>
                Free PDF Templates
              </Button>,
              <Button to="/" md toutlineext fullwidth>
                Go to Paperform
              </Button>,
            ]
          : null}
        <Button to={isPapersign ? '/sign' : '/dashboard'} md outline fullwidth>
          Sign In
        </Button>
        <Button to={registerUrl} md solid yellow fullwidth>
          {registerText}
        </Button>
      </div>
    </div>
  );
}

export default MobileMenu;
